import React, { useCallback, useRef } from 'react';
import SearchPicker, { PickerOption } from '../pettyCash/SearchPicker';
import e2iApi from '../../services/e2iApi';
import type { CustomerOption } from '../../types/e2i';

interface Props {
  id: string;
  companyId: number;
  value: CustomerOption | null;
  onChange: (value: CustomerOption | null) => void;
  required?: boolean;
  disabled?: boolean;
  helperText?: React.ReactNode;
}

/** An SAP customer of the company, searched by code or name (with its VAT number when SAP has one). */
const CustomerPicker: React.FC<Props> = ({ id, companyId, value, onChange, required, disabled, helperText }) => {
  const found = useRef(new Map<string, CustomerOption>());
  const search = useCallback(async (q: string): Promise<PickerOption[]> => {
    const rows = await e2iApi.customers(companyId, q);
    for (const r of rows) found.current.set(r.code, r);
    return rows.map((r) => ({ code: r.code, name: r.name, hint: r.federalTaxId ? `VAT ${r.federalTaxId}` : 'No VAT number in SAP' }));
  }, [companyId]);

  return (
    <SearchPicker
      id={id}
      label="Customer (SAP)"
      value={value ? { code: value.code, name: value.name } : null}
      onChange={(o) => onChange(o ? found.current.get(o.code) || { code: o.code, name: o.name, federalTaxId: value?.code === o.code ? value.federalTaxId : null } : null)}
      search={search}
      required={required}
      disabled={disabled}
      helperText={helperText}
      placeholder="Code or name"
    />
  );
};

export default CustomerPicker;
